import { applyMiddleware, combineReducers, createStore } from "redux";
import { createLogger } from "redux-logger";
import thunk from "redux-thunk";
import promise from "redux-promise-middleware";
import reducers from "./Reducers/Reducers";
import { pageBuilderApi } from "./Components/Menu/Settings/page-builder/api/pageBuilderApi";
import { packagesApi } from "./Components/Menu/Settings/page-builder/api/packagesApi";
import { commonApi } from "./Components/Menu/Settings/page-builder/api/commonApi";

//const persistedReducer = persistReducer(persistConfig, reducers);
const middlewares = [
    promise(),
    thunk,
    process.env.NODE_ENV !== 'test' ?
        createLogger({
            predicate: (_, action) => {
                return !action.type.startsWith('api.pageBuilder');
            }
        }) :
        undefined,
    pageBuilderApi.middleware,
    packagesApi.middleware,
    commonApi.middleware,
].filter((middleware): middleware is NonNullable<typeof middleware> => {
    return !!middleware;
}) as any[];

const middleware = applyMiddleware(...middlewares);

function createReducer(asyncReducers: any) {
    const reducer = combineReducers({
        ...reducers,
        ...asyncReducers
    }) as any;
    return (state: any, action: any) => {
        if (action.type === "USER_SET_CONNECTION" && action.payload.is_connected === false) {
            //storage.removeItem('persist:root');
            return reducer(undefined, action);
        }
        return reducer(state, action);
    };
}

function injectReducer(this: ReturnType<typeof createStore> & { asyncReducers: any }, key: string, reducer: any) {
    if (!this.asyncReducers) {
        this.asyncReducers = {};
    }
    this.asyncReducers[key] = reducer;
    this.replaceReducer(createReducer(this.asyncReducers) as any);
}

export const store: ReturnType<typeof createStore> & { asyncReducers: any } & {
    injectReducer: typeof injectReducer,
} = createStore(createReducer({}), middleware) as any;
(store as any).injectReducer = injectReducer.bind(store as any);

export const create = () => {
    const store: ReturnType<typeof createStore> & { asyncReducers: any } & {
        injectReducer: typeof injectReducer,
    } = createStore(createReducer({}), middleware) as any;
    (store as any).injectReducer = injectReducer.bind(store as any);
}